import getNumberOfAiGeneratedBlocks from './number-of-ai-generated-blocks';

export default {
  getNumberOfAiGeneratedBlocks,
};
